import { SafeLocalStorage } from '#pplx/frontend/browser-storage/localStorage.js';
const RBAC_REVISION_TOKEN_LS_PREFIX = 'rbac-revision-token:';
const getRevisionTokenStorageKey = (orgUuid) => `${RBAC_REVISION_TOKEN_LS_PREFIX}${orgUuid}`;
export function getStoredRevisionToken(orgUuid) {
    if (!orgUuid) {
        return undefined;
    }
    return SafeLocalStorage.getItem(getRevisionTokenStorageKey(orgUuid)) ?? undefined;
}
export function storeRevisionToken(orgUuid, revisionToken) {
    if (!orgUuid || !revisionToken) {
        return;
    }
    SafeLocalStorage.setItem(getRevisionTokenStorageKey(orgUuid), revisionToken);
}
//# sourceMappingURL=revisionToken.js.map